module.exports = __webpack_public_path__ + "static/media/vi.b41b18d9.svg";